<template>
    <div class="menu-item">  
        <a href="#/" class="button-menu" @mousedown="isOpen = !isOpen">
            {{ title }}
        </a>
        <transition name="fade" appear>
            <div class="sidebar" v-if="isOpen && secondTime">
                <a href="#/" class="close"  @click="isOpen = false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/></svg>
                    <h4>Κλείσιμο</h4>
                </a>
                <div class="menu-items">
                    <div v-for="(item,i) in items" :key="i" class="menu-item">
                        <a :href="item.link"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />{{ item.title }}</a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>
    .menu-item svg{
        width:10px;
        filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(262deg) brightness(100%) contrast(103%);
    }
    .button-menu{
        text-decoration: none !important;
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .menu-btn svg{
        margin-right: 10px;
    }
    .menu-item .sidebar{
        background-color: #fff;
        width:350px !important;
        height: 100% !important;
        position: fixed;
        right: 0px;
        top:0px;
        z-index: 99;
        box-shadow: -5px 4px 12px rgb(0 0 0 / 21%);
    }
    .close{
        background-color: #858ce1;
        padding:20px;
        display: flex;
        margin-bottom: 20px;
        border-bottom:1px solid #fff;
        justify-content: center;
        text-decoration: none;
    }
    .close svg{
        transform: scale(1.5);
        margin-right: 20px;
        margin-left: 10px;
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(203deg) brightness(104%) contrast(103%) !important;
    }
    .close h4{
        color:#fff;
        margin-bottom:0px !important;
		font-family:play !important;
		font-size:20px !important;
        margin-top: 0px !important;
    }
    .sidebar .menu-item {
        background-color: #fff;
        color:#686fcf;
        font-size: 20px;
        padding: 15px 20px;
        font-weight: 600;
        text-align: center;
    }
    .sidebar .menu-item a{
       width: 100%;
       text-align: left;
       padding: 10px 20px;
       text-align: center;
       text-decoration: none;
    }
    .sidebar .menu-item a{
        transition: none !important;
        
    }
    
    .sidebar .menu-item a:hover{
        background: #686fcf;
        border-radius: 10px;
        color:#fff;
    }
    
    .sidebar .menu-item:hover{
        background-color: #fff;     
    }

    .fade-enter-active,
    .fade-leave-active{
        transition: all .5s ease-out;
    }

    .fade-enter,
    .fade-leave-to{
        opacity: 0;
    }

@media only screen and (max-width: 767px) {
    .menu-item .sidebar{
        width:100% !important;
    }
}

</style>